import React from "react";
import SSSAccordion from "./SSSAccordion";
import { useTranslation } from "next-i18next";

function SSS({ data }) {
  const { t } = useTranslation(["common", "nav"]);

  return (
    <section className="container px-4 mx-auto bg-white lg:px-0">
      <div className="my-5 lg:my-10">
        <span className="relative z-30 text-4xl font-semibold text-after-shadow lg:text-5xl">{t('frequentlyAskedQuestions')}</span>
        <div className="grid grid-cols-2 mt-10 lg:gap-x-8">
          {data && Object.entries(data).map(([key, value]) => {
            return (
              <SSSAccordion key={key} title={key}>
                <div dangerouslySetInnerHTML={{ __html: value }}></div>
              </SSSAccordion>
            )
          })
          }
        </div>
      </div>

    </section>
  );
}

export default SSS;
